import { useCallback } from 'react'

import { useDispatch } from 'react-redux'

import type { Collection } from '@library/menu-service'

import { actionTypes } from 'actions/actionTypes'
import * as trackingKeys from 'actions/trackingKeys'

export function useTracking({
  menuId,
  collections,
}: {
  menuId: string
  collections: Collection[]
}) {
  const dispatch = useDispatch()

  return useCallback(() => {
    const collectionSlugs = collections.map((collection) => collection.slug)
    const collectionPositions = collectionSlugs.map((_, index) => index + 1)

    dispatch({
      type: actionTypes.COLLECTION_NAV_SHOWN,
      trackingData: {
        actionType: trackingKeys.collectionNavShown,
        collectionNamesArray: collectionSlugs,
        collectionPositionsArray: collectionPositions,
        menuId,
      },
    })
  }, [dispatch, collections, menuId])
}
